import React from 'react';
import type { BillingReferralProgram } from 'reactApp/modules/billingData/billingData.types';
import { Avatar } from 'reactApp/ui/Avatar/Avatar';

interface FriendAvatarProps {
    size: number;
    info: BillingReferralProgram;
}

export function FriendAvatar({
    size,
    info: {
        owner: { email },
    },
}: FriendAvatarProps) {
    const emailForAvatar = email.split('*').join('');
    return <Avatar email={emailForAvatar} name={emailForAvatar} size={size} />;
}
